const Scenarios = {
  MINIMUM: 0,
  EXPECTED: 50,
  POTENTIAL: 100
};

export default Scenarios;
